export default "__VITE_ASSET__Dp0SLDzX__"